import { useEffect, useRef } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import webPlayerHeartbeatService from "../services/webPlayerHeartbeat";
import webPlayerStorage from "../utils/webPlayerStorage";

/**
 * Global Heartbeat Manager
 * - Starts automatically when user is logged in (has token)
 * - Runs every 5 seconds via webPlayerHeartbeatService
 * - On failure: logs out user and redirects to login
 * - Does not run on login or switch-playlist pages
 * - Components can add listeners to receive heartbeat data
 */
const HeartbeatManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasSetupErrorListener = useRef(false);

  useEffect(() => {
    const token = webPlayerStorage.getToken();
    const isLoginPage = location.pathname === "/web-player/login";
    const isSwitchPlaylistPage =
      location.pathname === "/web-player/switch-playlist";

    if (isLoginPage || isSwitchPlaylistPage) {
      webPlayerHeartbeatService.stop();

      return;
    }

    if (token) {
      webPlayerHeartbeatService.start();
      if (!hasSetupErrorListener.current) {
        webPlayerHeartbeatService.addListener((data) => {
          if (
            data?.heartbeat?.status === 401 ||
            data?.heartbeat?.status === 403 ||
            data?.heartbeat?.auth === false ||
            (data?.heartbeat?.error &&
              (data.heartbeat.error.includes("auth") ||
                data.heartbeat.error.includes("token") ||
                data.heartbeat.error.includes("unauthorized")))
          ) {
            webPlayerHeartbeatService.stop();
            webPlayerStorage.clearAll();
            navigate("/web-player/login", { replace: true });
          }
        });
        hasSetupErrorListener.current = true;
      }
    } else {
      webPlayerHeartbeatService.stop();
    }

    return () => {
      // Don't stop on unmount - let it run globally
      // Only stop when explicitly navigating away or token is removed
    };
  }, [location.pathname, navigate]);

  return null;
};

export default HeartbeatManager;
